import {HttpPsFeeRepository} from '@infra/domain/model/PsFee/HttpPsFeeRepository';
import {PsFee} from '@domain/model/PsFee/PsFee';

const cache: {
  psFeeInfo?: PsFee;
} = {};

export const GetPsFeePayInfo = async (): Promise<PsFee> => {
  try {
    if (!cache.psFeeInfo) {
      cache.psFeeInfo = await HttpPsFeeRepository.getPsFeeInfo();
    }
    return cache.psFeeInfo;
  } catch (e) {
    return {
      payPsFee: true,
    };
  }
};
